import * as React from 'react';
import { DsiOptionWithDefinition as OptionWithDefinition } from './OptionWithDefinition';
import { __ } from 'react-i18n/lib';

interface Props {
  orderNr: string;
  state: string;
  price: string;
  currency: string;
  paymentState: string;
  note: string;
  customOrderNr: string;
}

function BaseOptions(props) {
  const {
    orderNr,
    state,
    price,
    currency,
    paymentState,
    note,
    customOrderNr,
  } = props;

  return (
    <>
      <OptionWithDefinition
        marginBottom={note || customOrderNr ? 16 : 0}
        title={`${__('Číslo objednávky')}`}
        value={orderNr}
      />
      {/* <OptionWithDefinition
        marginBottom={16}
        title={`${__('Stav')}`}
        value={state}
      /> */}
      {/* <OptionWithDefinition
        marginBottom={16}
        title={`${__('K úhrade')}`}
        value={`${price} ${currency}`}
      />
      <OptionWithDefinition
        title={`${__('Úhrada')}`}
        value={paymentState}
        fontColor={
          paymentState === __('Neuhradená')
            ? 'rgba(255, 30, 69, 0.92)'
            : paymentState === __('Uhradená')
            ? '#36BF91'
            : ''
        }
        marginBottom={16}
      /> */}
      {note ? (
        <OptionWithDefinition
          marginBottom={16}
          title={`${__('Poznámka')}`}
          value={note}
        />
      ) : null}
      {customOrderNr ? (
        <OptionWithDefinition
          title={
            <span>
              {__('Vlastné číslo')}
              <br />
              {__('objednávky')}
            </span>
          }
          value={customOrderNr}
        />
      ) : null}
    </>
  );
}

export { BaseOptions as DsiBaseOptions };
